import React, { Component } from "react";
import { Link } from "react-router-dom";
import TicketingCart from "../component/TicketingCart";
import MainLayout from "../mainLayout";
import TextField from "../component/TextField";
import CheckBox from "../component/CheckBox";
import TextEditor from "../component/TextEditor";
import upload from '../assets/images/cloud-data-upload-icon.svg';
//moment import
import moment from "moment-timezone";
//Service import
import service from "../services";
import Loader from "../component/loader";
//sweet alert
import swal from "sweetalert";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import EditIcon from "../icons/EditIcon";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import CalendarIcon from "../icons/calendaricon";
import DropDown from '../component/Dropdown';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import FooterConfiguration from "../component/FooterConfiguration";
import ProgramLinks from "../component/ProgramLinks";

let sub;

const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {}
    }
  ]
};
export default class HeaderFooterDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activetab: 0,
      getTickitingDetails: [],
      getTickitingDocs: [],
      loaderFlag: false,
      editDates:false,
      moduleName: '',
      startDate: new Date(),
      endDate: new Date(),
      shortProgrammeStartDate: null,
      shortProgrammeEndDate: null,
      headerStartDate: new Date(),
      headerEndDate: new Date(),
      footerStartDate: new Date(),
      footerEndDate: new Date(),
      start:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      end:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      shortStart:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      headerStart:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      shortEnd:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      headerEnd:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      footerStart:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      footerEnd:{
        hours:{value: '2', label: '2'},
        minutes:{value: '00', label: '00'},
        state:{value: 'AM', label: 'AM'},
      },
      updatedAt: moment.tz("US/Mountain").format(),
      data: [
        {
          label: "Festival Dates",
          Content: ""
        },
        {
          label: "Footer Links",
          Content: ""
        },
        {
          label: "Program Links",
          Content: ""
        },
      ],
      host:['PROD1', 'PROD2', 'PROD3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env.toLocaleLowerCase())) ? JSON.parse(process.env.REACT_APP_INSTANCE).filter(env => env.toLocaleLowerCase() === process.env.REACT_APP_ENVIRONMENT)[0] : JSON.parse(process.env.REACT_APP_INSTANCE)[0],
      evergreenToggle:false,
      logo:'',
      icon:'',
      emailLogo:'',
      referenceImage:'',
      isFooter : false,
      isHeader : false,
      isAppVisibility: false,
      appVisibility: false,
      isEdited: false,
      isWebConfigEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  updateState = (data, callback) => {
    this.setState({
      ...data,
      isEdited: true
    }, callback);
  }

  componentDidMount = async () => {
    this.getTickiting();
    this.getTickitingEvent();
    this.setState({
      loaderFlag: true,
      logo:this.apiserve.imageUrl+'assest/'+(['PROD1', 'PROD2', 'PROD3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env.toLocaleLowerCase())) ? this.state.host.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/sundance_logo.svg`+'?'+(new Date().getTime()),
      icon:this.apiserve.imageUrl+'assest/'+(['PROD1', 'PROD2', 'PROD3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env.toLocaleLowerCase())) ? this.state.host.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/sundance_favicon.png`+'?'+(new Date().getTime()),
      emailLogo:this.apiserve.imageUrl+'assest/'+(['PROD1', 'PROD2', 'PROD3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env.toLocaleLowerCase())) ? this.state.host.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/sundance_logo.png`+'?'+(new Date().getTime()),
      referenceImage:this.apiserve.imageUrl+'assest/'+(['PROD1', 'PROD2', 'PROD3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env.toLocaleLowerCase())) ? this.state.host.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/Reference-Image.png`+'?'+(new Date().getTime()),
    });
  };
  
  getTickitingEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "admin|getDateConfiguration":
          if (!response.error) {
            this.setState({ loaderFlag: false });
            // if(response.data.docs[0]){
              const latestRecord = [...response.data].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
              this.setState({
                updatedAt: latestRecord.updatedAt,
                updatedBy:{
                  fname: latestRecord.updatedBy ? latestRecord.updatedBy.fname : '',
                  lname: latestRecord.updatedBy ? latestRecord.updatedBy.lname : '',
                }
              })
              let newData = response.data.map((item) => {
                let hoursStart = moment(item.startDate).tz("US/Mountain").format('h');
                let minutesStart = moment(item.startDate).tz("US/Mountain").format('mm')
                let statestart = moment(item.startDate).tz("US/Mountain").format('A')
                let yearstart = moment(item.startDate).tz("US/Mountain").format('YYYY')
                let monthstart = moment(item.startDate).tz("US/Mountain").format('MM') - 1
                let datestart = moment(item.startDate).tz("US/Mountain").format('DD')
                let yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
                let monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
                let dateend = moment(item.endDate).tz("US/Mountain").format('DD')
                let hyearstart = moment(item.headerStartDate).tz("US/Mountain").format('YYYY')
                let hmonthstart = moment(item.headerStartDate).tz("US/Mountain").format('MM') - 1
                let hdatestart = moment(item.headerStartDate).tz("US/Mountain").format('DD')
                let hyearend = moment(item.headerEndDate).tz("US/Mountain").format('YYYY')
                let hmonthend = moment(item.headerEndDate).tz("US/Mountain").format('MM') - 1
                let hdateend = moment(item.headerEndDate).tz("US/Mountain").format('DD')
                let fyearstart = moment(item.footerStartDate).tz("US/Mountain").format('YYYY')
                let fmonthstart = moment(item.footerStartDate).tz("US/Mountain").format('MM') - 1
                let fdatestart = moment(item.footerStartDate).tz("US/Mountain").format('DD')
                let fyearend = moment(item.footerEndDate).tz("US/Mountain").format('YYYY')
                let fmonthend = moment(item.footerEndDate).tz("US/Mountain").format('MM') - 1
                let fdateend = moment(item.footerEndDate).tz("US/Mountain").format('DD')
                let hoursend = moment(item.endDate).tz("US/Mountain").format('h');
                let minutesend = moment(item.endDate).tz("US/Mountain").format('mm')
                let stateend = moment(item.endDate).tz("US/Mountain").format('A')
                let data = {
                  module:item.module,
                  startDate : new Date(yearstart, monthstart, datestart),
                  endDate : new Date(yearend, monthend, dateend),
                  headerStartDate : new Date(fyearstart, fmonthstart, fdatestart),
                  headerEndDate : new Date(fyearend, fmonthend, fdateend),
                  footerStartDate : new Date(fyearstart, fmonthstart, fdatestart),
                  footerEndDate : new Date(fyearend, fmonthend, fdateend)
                }
                return data
              })
              const grouped = {
                FPG: [],
                TICKETING: [],
                MY_FESTIVAL: [],
                EVENTS: [],
                OTHER: [],
              };
              response.data.sort((a, b) => {
                if (a.configLevel === b.configLevel) return 0;
                return a.configLevel === "top" ? -1 : 1;
              }).forEach((item) => {
                if (item.module.startsWith("FPG")) {
                  grouped.FPG.push(item);
                } else if (item.module.startsWith("TICKETING")) {
                  grouped.TICKETING.push(item);
                } else if (item.module.startsWith("MY")) {
                  grouped.MY_FESTIVAL.push(item);
                } else if (item.module.startsWith("EVENT")) {
                  item.isAppVisibility = true;
                  grouped.EVENTS.push(item);
                } else {
                  grouped.OTHER.push(item);
                }
              });
              this.setState({
                getTickitingDocs: grouped,
                loaderFlag: false,
                isEdited: false
              });
            // }else this.setState({ loaderFlag: false });
          } else this.setState({ loaderFlag: false });
          break;
        case "admin|dateConfiguration":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              editDates:false,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false,}, () =>
              this.apiserve.success("Updated successful.")
            );
            this.getTickiting();
          }
          break;
        case "admin|copyDateConfiguration":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              editDates:false,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false,}, () =>
              this.apiserve.success("Updated successful.")
            );
            this.getTickiting();
          }
          break;
        case "ticketCms|ticketHome|create":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () =>
              this.apiserve.success("Ticketing Created successful.")
            );
          }
      }
    });
  };

  getTickiting = () => {
    this.apiserve.sendevent("admin|getDateConfiguration", {'host':this.state.host});
  };


  getMtTime = (date) => {
    //Get offset from mountain time using UTC
    //change 360 t0 420
    let ABBR = moment.tz("America/Denver").format("z");
    let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    // add that offset in date
    return moment(date).add(offDifference, 'minutes').toISOString()
  }
  // handelChange = e => {
  //   this.setState({
  //     [e.target.name]: e.target.value
  //   });
  // };

  submitFn = async e => {
    e.preventDefault();
    let startDate = this.getMtTime(this.state.startDate.setHours(this.state.start.state.value === 'PM' || this.state.start.state.value === 'pm' ? parseInt(this.state.start.hours.value) === 12 ? parseInt(this.state.start.hours.value) : parseInt(this.state.start.hours.value) + 12 : parseInt(this.state.start.hours.value) === 12 ? parseInt(this.state.start.hours.value) - 12 : parseInt(this.state.start.hours.value), this.state.start.minutes.value))
    let endDate = this.getMtTime(this.state.endDate.setHours(this.state.end.state.value === 'PM' || this.state.end.state.value === 'pm' ? parseInt(this.state.end.hours.value) === 12 ? parseInt(this.state.end.hours.value) : parseInt(this.state.end.hours.value) + 12 : parseInt(this.state.end.hours.value) === 12 ? parseInt(this.state.end.hours.value) - 12 : parseInt(this.state.end.hours.value), this.state.end.minutes.value))
    let shortProgrammeStartDate = this.state.shortProgrammeStartDate !== null ? this.getMtTime(this.state.shortProgrammeStartDate.setHours(this.state.shortStart.state.value === 'PM' || this.state.shortStart.state.value === 'pm' ? parseInt(this.state.shortStart.hours.value) === 12 ? parseInt(this.state.shortStart.hours.value) : parseInt(this.state.shortStart.hours.value) + 12 : parseInt(this.state.shortStart.hours.value) === 12 ? parseInt(this.state.shortStart.hours.value) - 12 : parseInt(this.state.shortStart.hours.value), this.state.shortStart.minutes.value)) : null
    let shortProgrammeEndDate = this.state.shortProgrammeEndDate !== null ? this.getMtTime(this.state.shortProgrammeEndDate.setHours(this.state.shortEnd.state.value === 'PM' || this.state.shortEnd.state.value === 'pm' ? parseInt(this.state.shortEnd.hours.value) === 12 ? parseInt(this.state.shortEnd.hours.value) : parseInt(this.state.shortEnd.hours.value) + 12 : parseInt(this.state.shortEnd.hours.value) === 12 ? parseInt(this.state.shortEnd.hours.value) - 12 : parseInt(this.state.shortEnd.hours.value), this.state.shortEnd.minutes.value)) : null
    let hstartDate = this.getMtTime(this.state.headerStartDate.setHours(this.state.headerStart.state.value === 'PM' || this.state.headerStart.state.value === 'pm' ? parseInt(this.state.headerStart.hours.value) === 12 ? parseInt(this.state.headerStart.hours.value) : parseInt(this.state.headerStart.hours.value) + 12 : parseInt(this.state.headerStart.hours.value) === 12 ? parseInt(this.state.headerStart.hours.value) - 12 : parseInt(this.state.headerStart.hours.value), this.state.headerStart.minutes.value))
    let hendDate = this.getMtTime(this.state.headerEndDate.setHours(this.state.headerEnd.state.value === 'PM' || this.state.headerEnd.state.value === 'pm' ? parseInt(this.state.headerEnd.hours.value) === 12 ? parseInt(this.state.headerEnd.hours.value) : parseInt(this.state.headerEnd.hours.value) + 12 : parseInt(this.state.headerEnd.hours.value) === 12 ? parseInt(this.state.headerEnd.hours.value) - 12 : parseInt(this.state.headerEnd.hours.value), this.state.headerEnd.minutes.value))
    let fstartDate = this.getMtTime(this.state.footerStartDate.setHours(this.state.footerStart.state.value === 'PM' || this.state.footerStart.state.value === 'pm' ? parseInt(this.state.footerStart.hours.value) === 12 ? parseInt(this.state.footerStart.hours.value) : parseInt(this.state.footerStart.hours.value) + 12 : parseInt(this.state.footerStart.hours.value) === 12 ? parseInt(this.state.footerStart.hours.value) - 12 : parseInt(this.state.footerStart.hours.value), this.state.footerStart.minutes.value))
    let fendDate = this.getMtTime(this.state.footerEndDate.setHours(this.state.footerEnd.state.value === 'PM' || this.state.footerEnd.state.value === 'pm' ? parseInt(this.state.footerEnd.hours.value) === 12 ? parseInt(this.state.footerEnd.hours.value) : parseInt(this.state.footerEnd.hours.value) + 12 : parseInt(this.state.footerEnd.hours.value) === 12 ? parseInt(this.state.footerEnd.hours.value) - 12 : parseInt(this.state.footerEnd.hours.value), this.state.footerEnd.minutes.value))
    let data = {
      module:this.state.moduleName,
      startDate :startDate,
      endDate:endDate,
      headerStartDate :hstartDate,
      headerEndDate:hendDate,
      footerStartDate :fstartDate,
      footerEndDate:fendDate,
      host:this.state.host
    }
    
    if(shortProgrammeStartDate !== null && shortProgrammeEndDate !== null){
      data.shortProgrammeStartDate = shortProgrammeStartDate
      data.shortProgrammeEndDate = shortProgrammeEndDate
    }

    if(this.state.isAppVisibility){
      data.appVisibility = this.state.appVisibility
    }

    if((startDate < endDate) && (hstartDate < hendDate || !this.state.isHeader) && (fstartDate < fendDate || !this.state.isFooter) && ((shortProgrammeStartDate === null && shortProgrammeEndDate === null) || (shortProgrammeStartDate < shortProgrammeEndDate))){
      startDate = moment(startDate)
      endDate = moment(endDate)
      if(this.state.moduleName === 'CALENDER_DATES' && endDate.diff(startDate, 'days') < 10){
        this.setState({
          errorMsg:true,
          errorMsgShow:'EndDate must be greater then 10 days from Startdate.'
        })
      } else if((this.state.moduleName === 'FESTIVAL_FIRST_HALF' && endDate.diff(startDate, 'days') > 5) || (this.state.moduleName === 'FESTIVAL_SECOND_HALF' && endDate.diff(startDate, 'days') > 5)){
        this.setState({
          errorMsg:true,
          errorMsgShow:'EndDate must be 5 days from Startdate.'
        })
      } else {
        this.setState({ loaderFlag: true });
        this.apiserve.sendevent("admin|dateConfiguration", data);
      }
    } else {
      this.setState({
        errorMsg:true,
        errorMsgShow:'End date must be later then start date.'
      })
    }
  };
  TabClick = index => {
    this.setState({
      activetab: index
    }, () => {
      this.getTickiting()
    });
  };
  validateModel = () => {
    this.setState({
      errorMsg: false
    });
  };

  cancelBTN = e => {
    e.preventDefault();
    window.location.reload();
    // this.props.history.push({pathaname: '/ticketing'})
  };

  handleChangeDate = (date, type) => {
    if(type === 'startDate'){
      if(date > this.state.headerStartDate && date > this.state.footerStartDate){
        this.updateState({
          startDate: date,
          headerStartDate: date,
          footerStartDate: date
        })
      } else if(date > this.state.headerStartDate){
        this.updateState({
          startDate: date,
          headerStartDate: date
        })
      } else if(date > this.state.footerStartDate){
        this.updateState({
          startDate: date,
          footerStartDate: date
        })
      } else {
        this.updateState({
          startDate: date
        })
      }
    } else if(type === 'headerStartDate'){
      this.updateState({
        headerStartDate: date
      })
    } else if(type === 'headerEndDate'){
      this.updateState({
        headerEndDate: date
      })
    } else if(type === 'footerStartDate'){
      this.updateState({
        footerStartDate: date
      })
    } else if(type === 'footerEndDate'){
      this.updateState({
        footerEndDate: date
      })
    } else if(type === 'shortProgrammeStartDate'){
      this.updateState({
        shortProgrammeStartDate: date
      })
    } else if(type === 'shortProgrammeEndDate'){
      this.updateState({
        shortProgrammeEndDate: date
      })
    } else {
      if(date < this.state.headerEndDate && date < this.state.footerEndDate){
        this.updateState({
          endDate: date,
          headerEndDate: date,
          footerEndDate: date
        })
      } else if(date < this.state.headerEndDate){
        this.updateState({
          endDate: date,
          headerEndDate: date
        })
      } else if(date < this.state.footerEndDate){
        this.updateState({
          endDate: date,
          footerEndDate: date
        })
      } else {
        this.updateState({
          endDate: date
        })
      }
    }
  }
  handleChangeInstance = (e) => {
    this.setState({
      host: e.target.value,
      logo:this.apiserve.imageUrl+'assest/'+(['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? e.target.value.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/sundance_logo.svg`+'?'+(new Date().getTime()),
      icon:this.apiserve.imageUrl+'assest/'+(['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? e.target.value.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/sundance_favicon.png`+'?'+(new Date().getTime()),
      emailLogo:this.apiserve.imageUrl+'assest/'+(['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? e.target.value.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/sundance_logo.png`+'?'+(new Date().getTime()),
      referenceImage:this.apiserve.imageUrl+'assest/'+(['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? e.target.value.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT)+`/Reference-Image.png`+'?'+(new Date().getTime()),
    })
    if(this.state.activetab === 1){
      this.apiserve.sendevent("admin|Footer|getConfig", { host: e.target.value });
    } else {
      this.apiserve.sendevent("admin|getDateConfiguration", {'host':e.target.value});
    }
  }

  handleTimeHours = (e, type) => {
    this.updateState({})
    if(type === 'startDate'){
      this.state.start.hours = e
    } else if(type === 'shortProgrammeStartDate'){
      this.state.shortStart.hours = e
    } else if(type === 'shortProgrammeEndDate'){
      this.state.shortEnd.hours = e
    } else if(type === 'headerStartDate'){
      this.state.headerStart.hours = e
    } else if(type === 'headerEndDate'){
      this.state.headerEnd.hours = e
    } else if(type === 'footerStartDate'){
      this.state.footerStart.hours = e
    } else if(type === 'footerEndDate'){
      this.state.footerEnd.hours = e
    } else {
      this.state.end.hours = e
    }
  }

  handleTimeMin = (e, type) => {
    this.updateState({})
    if(type === 'startDate'){
      this.state.start.minutes = e
    } else if(type === 'shortProgrammeStartDate'){
      this.state.shortStart.minutes = e
    } else if(type === 'shortProgrammeEndDate'){
      this.state.shortEnd.minutes = e
    } else if(type === 'headerStartDate'){
      this.state.headerStart.minutes = e
    } else if(type === 'headerEndDate'){
      this.state.headerEnd.minutes = e
    } else if(type === 'footerStartDate'){
      this.state.footerStart.minutes = e
    } else if(type === 'footerEndDate'){
      this.state.footerEnd.minutes = e
    } else {
      this.state.end.minutes = e
    }
  }

  handleTimeStamps = (e, type) => {
    this.updateState({})
    if(type === 'startDate'){
      this.state.start.state = e
    } else if(type === 'shortProgrammeStartDate'){
      this.state.shortStart.state = e
    } else if(type === 'shortProgrammeEndDate'){
      this.state.shortEnd.state = e
    } else if(type === 'headerStartDate'){
      this.state.headerStart.state = e
    } else if(type === 'headerEndDate'){
      this.state.headerEnd.state = e
    } else if(type === 'footerStartDate'){
      this.state.footerStart.state = e
    } else if(type === 'footerEndDate'){
      this.state.footerEnd.state = e
    } else {
      this.state.end.state = e
    }
  }

  editTalkEventListData = (e,item) => {
    e.stopPropagation();
    e.preventDefault();
    let hoursStart = moment(item.startDate).tz("US/Mountain").format('h');
    let minutesStart = moment(item.startDate).tz("US/Mountain").format('mm')
    let statestart = moment(item.startDate).tz("US/Mountain").format('A')
    let yearstart = moment(item.startDate).tz("US/Mountain").format('YYYY')
    let monthstart = moment(item.startDate).tz("US/Mountain").format('MM') - 1
    let datestart = moment(item.startDate).tz("US/Mountain").format('DD')
    let yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
    let monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
    let dateend = moment(item.endDate).tz("US/Mountain").format('DD')
    let hoursend = moment(item.endDate).tz("US/Mountain").format('h');
    let minutesend = moment(item.endDate).tz("US/Mountain").format('mm')
    let stateend = moment(item.endDate).tz("US/Mountain").format('A')
    let shoursStart = moment(item.shortProgrammeStartDate).tz("US/Mountain").format('h');
    let sminutesStart = moment(item.shortProgrammeStartDate).tz("US/Mountain").format('mm')
    let sstatestart = moment(item.shortProgrammeStartDate).tz("US/Mountain").format('A')
    let syearstart = moment(item.shortProgrammeStartDate).tz("US/Mountain").format('YYYY')
    let smonthstart = moment(item.shortProgrammeStartDate).tz("US/Mountain").format('MM') - 1
    let sdatestart = moment(item.shortProgrammeStartDate).tz("US/Mountain").format('DD')
    let syearend = moment(item.shortProgrammeEndDate).tz("US/Mountain").format('YYYY')
    let smonthend = moment(item.shortProgrammeEndDate).tz("US/Mountain").format('MM') - 1
    let sdateend = moment(item.shortProgrammeEndDate).tz("US/Mountain").format('DD')
    let shoursend = moment(item.shortProgrammeEndDate).tz("US/Mountain").format('h');
    let sminutesend = moment(item.shortProgrammeEndDate).tz("US/Mountain").format('mm')
    let sstateend = moment(item.shortProgrammeEndDate).tz("US/Mountain").format('A')
    let hhoursStart = moment(item.headerStartDate).tz("US/Mountain").format('h');
    let hminutesStart = moment(item.headerStartDate).tz("US/Mountain").format('mm')
    let hstatestart = moment(item.headerStartDate).tz("US/Mountain").format('A')
    let hyearstart = moment(item.headerStartDate).tz("US/Mountain").format('YYYY')
    let hmonthstart = moment(item.headerStartDate).tz("US/Mountain").format('MM') - 1
    let hdatestart = moment(item.headerStartDate).tz("US/Mountain").format('DD')
    let hyearend = moment(item.headerEndDate).tz("US/Mountain").format('YYYY')
    let hmonthend = moment(item.headerEndDate).tz("US/Mountain").format('MM') - 1
    let hdateend = moment(item.headerEndDate).tz("US/Mountain").format('DD')
    let hhoursend = moment(item.headerEndDate).tz("US/Mountain").format('h');
    let hminutesend = moment(item.headerEndDate).tz("US/Mountain").format('mm')
    let hstateend = moment(item.headerEndDate).tz("US/Mountain").format('A')
    let fhoursStart = moment(item.footerStartDate).tz("US/Mountain").format('h');
    let fminutesStart = moment(item.footerStartDate).tz("US/Mountain").format('mm')
    let fstatestart = moment(item.footerStartDate).tz("US/Mountain").format('A')
    let fyearstart = moment(item.footerStartDate).tz("US/Mountain").format('YYYY')
    let fmonthstart = moment(item.footerStartDate).tz("US/Mountain").format('MM') - 1
    let fdatestart = moment(item.footerStartDate).tz("US/Mountain").format('DD')
    let fyearend = moment(item.footerEndDate).tz("US/Mountain").format('YYYY')
    let fmonthend = moment(item.footerEndDate).tz("US/Mountain").format('MM') - 1
    let fdateend = moment(item.footerEndDate).tz("US/Mountain").format('DD')
    let fhoursend = moment(item.footerEndDate).tz("US/Mountain").format('h');
    let fminutesend = moment(item.footerEndDate).tz("US/Mountain").format('mm')
    let fstateend = moment(item.footerEndDate).tz("US/Mountain").format('A')
    this.setState({
      editDates: true,
      moduleName: item.module,
      startDate: new Date(yearstart, monthstart, datestart),
      endDate: new Date(yearend, monthend, dateend),
      start:{
        hours: { value: hoursStart, label: hoursStart },
        minutes: { value: minutesStart, label: minutesStart },
        state: { value: statestart, label: statestart }
      },
      end:{
        hours: { value: hoursend, label: hoursend },
        minutes: { value: minutesend, label: minutesend },
        state: { value: stateend, label: stateend }
      },
      shortProgrammeStartDate: item.hasOwnProperty('shortProgrammeStartDate') ? new Date(syearstart, smonthstart, sdatestart) : null,
      shortProgrammeEndDate: item.hasOwnProperty('shortProgrammeEndDate') ? new Date(syearend, smonthend, sdateend) : null,
      shortStart:{
        hours: { value: shoursStart, label: shoursStart },
        minutes: { value: sminutesStart, label: sminutesStart },
        state: { value: sstatestart, label: sstatestart }
      },
      shortEnd:{
        hours: { value: shoursend, label: shoursend },
        minutes: { value: sminutesend, label: sminutesend },
        state: { value: sstateend, label: sstateend }
      },
      headerStartDate: new Date(hyearstart, hmonthstart, hdatestart),
      headerEndDate: new Date(hyearend, hmonthend, hdateend),
      headerStart:{
        hours: { value: hhoursStart, label: hhoursStart },
        minutes: { value: hminutesStart, label: hminutesStart },
        state: { value: hstatestart, label: hstatestart }
      },
      headerEnd:{
        hours: { value: hhoursend, label: hhoursend },
        minutes: { value: hminutesend, label: hminutesend },
        state: { value: hstateend, label: hstateend }
      },
      footerStartDate: new Date(fyearstart, fmonthstart, fdatestart),
      footerEndDate: new Date(fyearend, fmonthend, fdateend),
      footerStart:{
        hours: { value: fhoursStart, label: fhoursStart },
        minutes: { value: fminutesStart, label: fminutesStart },
        state: { value: fstatestart, label: fstatestart }
      },
      footerEnd:{
        hours: { value: fhoursend, label: fhoursend },
        minutes: { value: fminutesend, label: fminutesend },
        state: { value: fstateend, label: fstateend }
      },
      isFooter: item.isFooter ? item.isFooter : false,
      isHeader: item.isHeader ? item.isHeader : false,
      isAppVisibility: item.isAppVisibility ? item.isAppVisibility : false,
      appVisibility: item.hasOwnProperty('appVisibility') ? item.appVisibility : false,
      isEdited: false
    })
  };

  CloseModal = () => {
    this.setState({
        editDates: false,
    })
  }

  cloneData = () => {
    this.setState({ clonePopup: true });
  }

  onInputChangeDropDown = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  submitClone = (e) => {
    if(this.validator.allValid()){
      this.setState({ clonePopup: false, isClone: true });
    } else {
      this.validator.showMessages();
    }
  }

  cancelClone = (e) => {
    this.setState({ isClone: false, clonePopup: false });
  }

  yesCloneData = () => {
    this.setState({ isClone: false });
    this.apiserve.sendevent("admin|copyDateConfiguration", {
      "from": this.state.from,
      "to": this.state.to,
    });
  }

  render() {
    const { updatedAt } = this.state;
    const hours = [
      { value: '12', label: '12' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
  ]

  const minutes = [
      { value: '00', label: '00' },
      { value: '05', label: '05' },
      { value: '10', label: '10' },
      { value: '15', label: '15' },
      { value: '20', label: '20' },
      { value: '25', label: '25' },
      { value: '30', label: '30' },
      { value: '35', label: '35' },
      { value: '40', label: '40' },
      { value: '45', label: '45' },
      { value: '50', label: '50' },
      { value: '55', label: '55' },
  ]

  const state = [
      { value: 'AM', label: 'AM' },
      { value: 'PM', label: 'PM' }
  ]

  const instance = JSON.parse(process.env.REACT_APP_INSTANCE)
    var updatedBy = `${this.state.updatedBy?.fname ? this.state.updatedBy?.fname : ""} ${this.state.updatedBy?.lname ? this.state.updatedBy?.lname : ""}`;
    // console.log('this.state.ticket1',this.state.ticket1.getCurrentContent().getPlainText());
    return (
      <React.Fragment>
        <div className="right_side_wrapper artistView_wrapper">
          <ul className="fpg_admin_tab disp_flex small_list_tab">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li
                    className={this.state.activetab === index ? "active" : ""}
                    onClick={() => this.TabClick(index)}
                  >
                    <p className="uppercase">
                      <div>{list.label}</div>
                    </p>
                  </li>
                );
              })}
          </ul>
          <div className="instane_dropdown">
            {instance.length > 1 && this.state.activetab === 0 && <button className='sd_update_list_btn' onClick={() => this.cloneData()}><svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none"><path d="M4 5.4C4 4.622 4.622 4 5.4 4h7.2c.778 0 1.4.622 1.4 1.4V6a1 1 0 1 0 2 0v-.6C16 3.518 14.482 2 12.6 2H5.4A3.394 3.394 0 0 0 2 5.4v7.2C2 14.482 3.518 16 5.4 16H6a1 1 0 1 0 0-2h-.6c-.778 0-1.4-.622-1.4-1.4V5.4Z" fill="#000000"/><path d="M9 11.4A2.4 2.4 0 0 1 11.4 9h7.2a2.4 2.4 0 0 1 2.4 2.4v7.2a2.4 2.4 0 0 1-2.4 2.4h-7.2A2.4 2.4 0 0 1 9 18.6v-7.2Z" fill="#000000"/></svg>Clone Dates</button>}
            <DropDown name='host' options={instance} onChange={this.handleChangeInstance} value={this.state?.host} label="" />
          </div>
          {this.state.activetab === 0 ? (
            <>
              <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                {/* <Link className="back_link"> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black"/> </svg> Back to List</Link> */}
                <p></p>
                <p className="update_date">
                  Last Update: {moment(updatedAt).format("hh:mm A")} MT -{moment(updatedAt).format("MM/DD/YYYY")} Last Updated
                  By: {updatedBy ? updatedBy : ""}
                </p>
              </div>
              <div className="ticketing_content">
                <div className="table_wrap product_list_tbl date_congiguration">
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Module Name</th>
                        <th>Start Date (MT)</th>
                        <th>End Date (MT)</th>
                        <th></th>
                      </tr>
                    </thead>
                  </table>
                  <table>
                    <tbody>
                      <tr>
                        <Accordion allowZeroExpanded={true} preExpanded={['0']}>
                          {Object.entries(this.state.getTickitingDocs).map((item,i) => {
                            return ( 
                              <AccordionItem uuid={i.toString()}>
                                  <div className='sd_mobile_mobiscroll_block film_list_table striped_table' >
                                    <AccordionItemHeading className="main_heading">
                                      <AccordionItemButton >
                                      <table>
                                        <tbody>
                                          {item[1].map((innerItem, index) => {
                                            const isSpecial = item[0] === 'FPG' || item[0] === 'TICKETING';
                                            return (index === 0 &&
                                              <tr className={`${moment(innerItem.startDate) < moment(new Date()) && moment(innerItem.endDate) > moment(new Date()) && isSpecial ? "com-step" : " "}`}>
                                                <td></td>
                                                <td>{isSpecial ? innerItem.module.replace(/_/g, ' ') : item[0].replace(/_/g, ' ')}</td>
                                                <td>{isSpecial ? `${moment(innerItem.startDate).tz("US/Mountain").format('MMM DD YYYY')} ${moment(innerItem.startDate).tz("US/Mountain").format('h:mm A')}` : ''}</td>
                                                <td>{isSpecial ? `${moment(innerItem.endDate).tz("US/Mountain").format('MMM DD YYYY')} ${moment(innerItem.endDate).tz("US/Mountain").format('h:mm A')}` : ''}</td>
                                                <td>
                                                  {isSpecial && <span className="pointer"  onClick={(e) => this.editTalkEventListData(e,innerItem)}><EditIcon /></span>}
                                                </td>
                                              </tr>
                                            )
                                          })}
                                        </tbody>
                                      </table>
                                      </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                    <table>
                                      <tbody>
                                        {item[1].map((innerItem, index) => {
                                          const isSpecial = item[0] === 'FPG' || item[0] === 'TICKETING';
                                          if (isSpecial && index === 0) return null; // Skip index 0 for FPG and TICKETING
                                          return (
                                            <tr className={`${moment(innerItem.startDate) < moment(new Date()) && moment(innerItem.endDate) > moment(new Date()) ? "com-step" : " "}`}>
                                              <td></td>
                                              <td>{innerItem.module === "MY_SCHEDULE_EE_BUTTON" ? " ORDER TICKETS EE BUTTON" : innerItem.module.replace(/_/g, ' ')}</td>
                                              <td>{moment(innerItem.startDate).tz("US/Mountain").format('MMM DD YYYY')} {moment(innerItem.startDate).tz("US/Mountain").format('h:mm A')}</td>
                                              <td>{moment(innerItem.endDate).tz("US/Mountain").format('MMM DD YYYY')} {moment(innerItem.endDate).tz("US/Mountain").format('h:mm A')}</td>
                                              <td>
                                                <span className="pointer"  onClick={(e) => this.editTalkEventListData(e,innerItem)}><EditIcon /></span>
                                              </td>
                                            </tr>
                                          )
                                        })}
                                      </tbody>
                                    </table>
                                  </AccordionItemPanel>
                                </div>
                              </AccordionItem> 
                            )
                          })}
                        </Accordion>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : this.state.activetab === 1 ? (
            <FooterConfiguration host={this.state.host} />
          ) : (
            <ProgramLinks host={this.state.host} />
          )}
          
        </div>
        {/* popup */}
       {this.state.editDates && <div className={`user_popup ${this.state.editDates ? "active" : ""}`} >
            <span className="popup_overlay" onClick={this.CloseModal}></span>
            <div className="cat_modal_inner sd_hf_modal">
                <p className="cat_title text_center">
                  {this.state.moduleName === "MY_SCHEDULE_EE_BUTTON" ? "ORDER TICKETS EE BUTTON" : this.state.moduleName.replace(/_/g, ' ')}
                </p>
                <form>
                    <div className="field_row create_feature_col mx_100">
                      <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                          <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                              <label>Start Date & Time (MT)</label>
                              <div className="form_group_countdown">
                                  <>
                                      <TextField type="text" name="countDownDate"
                                          value={moment(this.state.startDate).format(
                                            "MM/DD/YYYY"
                                            )}
                                            placeholder="mm / dd / yyyy"
                                            />

                                      <span className="calendar_img">
                                          <DatePicker
                                              selected={new Date(this.state.startDate)}
                                              onChange={(e) => this.handleChangeDate(e, 'startDate')}
                                              minDate={moment().tz("US/Mountain").toDate()}
                                              placeholder="mm/dd/yyyy"
                                              customInput={
                                                  <span className="calendar">
                                                      <CalendarIcon />
                                                  </span>
                                              }
                                          />
                                      </span>
                                      <Select
                                          options={hours}
                                          value={this.state.start.hours}
                                          name='hours'
                                          placeholder="7"
                                          onChange={(e) => this.handleTimeHours(e, 'startDate')} />
                                      <Select
                                          options={minutes}
                                          value={this.state.start.minutes}
                                          name='minutes'
                                          placeholder="30"
                                          onChange={(e) => this.handleTimeMin(e, 'startDate')} />
                                      <Select
                                          options={state}
                                          value={this.state.start.state}
                                          name='state'
                                          placeholder="AM"
                                          onChange={(e) => this.handleTimeStamps(e, 'startDate')} />
                                  </>
                              </div>
                          </div>
                      </div>

                      {/* endDate */}
                      <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                          <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                              <label>End Date & Time (MT)</label>
                              <div className="form_group_countdown">
                                  <>
                                      <TextField type="text" name="countDownDate"
                                          value={moment(this.state.endDate).format(
                                              "MM/DD/YYYY"
                                          )}
                                          placeholder="mm / dd / yyyy"
                                      />

                                      <span className="calendar_img">
                                          <DatePicker
                                              selected={this.state.endDate}
                                              onChange={(e) => this.handleChangeDate(e, 'endDate')}
                                              minDate={moment(this.state.startDate).toDate()}
                                              placeholder="mm/dd/yyyy"
                                              customInput={
                                                  <span className="calendar">
                                                      <CalendarIcon />
                                                  </span>
                                              }
                                          />
                                      </span>
                                      <Select
                                          options={hours}
                                          value={this.state.end.hours}
                                          name='hours'
                                          placeholder="7"
                                          onChange={(e) => this.handleTimeHours(e, 'endDate')} />
                                      <Select
                                          options={minutes}
                                          value={this.state.end.minutes}
                                          name='minutes'
                                          placeholder="30"
                                          onChange={(e) => this.handleTimeMin(e, 'endDate')} />
                                      <Select
                                          options={state}
                                          value={this.state.end.state}
                                          name='state'
                                          placeholder="AM"
                                          onChange={(e) => this.handleTimeStamps(e, 'endDate')} />
                                  </>
                              </div>
                          </div>
                      </div>
                      {this.state.shortProgrammeStartDate !== null && this.state.shortProgrammeEndDate !== null && 
                      <>
                        <h3 className="w_100 d_block">Short Program</h3>
                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                <label>Start Date & Time (MT)</label>
                                <div className="form_group_countdown">
                                    <>
                                        <TextField type="text" name="countDownDate"
                                            value={moment(this.state.shortProgrammeStartDate).format(
                                              "MM/DD/YYYY"
                                              )}
                                              placeholder="mm / dd / yyyy"
                                              />

                                        <span className="calendar_img">
                                            <DatePicker
                                                selected={new Date(this.state.shortProgrammeStartDate)}
                                                onChange={(e) => this.handleChangeDate(e, 'shortProgrammeStartDate')}
                                                minDate={moment().tz("US/Mountain").toDate()}
                                                placeholder="mm/dd/yyyy"
                                                customInput={
                                                    <span className="calendar">
                                                        <CalendarIcon />
                                                    </span>
                                                }
                                            />
                                        </span>
                                        <Select
                                            options={hours}
                                            value={this.state.shortStart.hours}
                                            name='hours'
                                            placeholder="7"
                                            onChange={(e) => this.handleTimeHours(e, 'shortProgrammeStartDate')} />
                                        <Select
                                            options={minutes}
                                            value={this.state.shortStart.minutes}
                                            name='minutes'
                                            placeholder="30"
                                            onChange={(e) => this.handleTimeMin(e, 'shortProgrammeStartDate')} />
                                        <Select
                                            options={state}
                                            value={this.state.shortStart.state}
                                            name='state'
                                            placeholder="AM"
                                            onChange={(e) => this.handleTimeStamps(e, 'shortProgrammeStartDate')} />
                                    </>
                                </div>
                            </div>
                        </div>

                        {/* endDate */}
                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                <label>End Date & Time (MT)</label>
                                <div className="form_group_countdown">
                                    <>
                                        <TextField type="text" name="countDownDate"
                                            value={moment(this.state.shortProgrammeEndDate).format(
                                                "MM/DD/YYYY"
                                            )}
                                            placeholder="mm / dd / yyyy"
                                        />

                                        <span className="calendar_img">
                                            <DatePicker
                                                selected={this.state.shortProgrammeEndDate}
                                                onChange={(e) => this.handleChangeDate(e, 'shortProgrammeEndDate')}
                                                minDate={moment().tz("US/Mountain").toDate()}
                                                placeholder="mm/dd/yyyy"
                                                customInput={
                                                    <span className="calendar">
                                                        <CalendarIcon />
                                                    </span>
                                                }
                                            />
                                        </span>
                                        <Select
                                            options={hours}
                                            value={this.state.shortEnd.hours}
                                            name='hours'
                                            placeholder="7"
                                            onChange={(e) => this.handleTimeHours(e, 'shortProgrammeEndDate')} />
                                        <Select
                                            options={minutes}
                                            value={this.state.shortEnd.minutes}
                                            name='minutes'
                                            placeholder="30"
                                            onChange={(e) => this.handleTimeMin(e, 'shortProgrammeEndDate')} />
                                        <Select
                                            options={state}
                                            value={this.state.shortEnd.state}
                                            name='state'
                                            placeholder="AM"
                                            onChange={(e) => this.handleTimeStamps(e, 'shortProgrammeEndDate')} />
                                    </>
                                </div>
                            </div>
                        </div>
                      </>}
                      {this.state.isHeader && <>
                        <hr></hr>
                        <h3 className="w_100 d_block">Header</h3>
                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                <label>Start Date & Time (MT)</label>
                                <div className="form_group_countdown">
                                    <>
                                        <TextField type="text" name="countDownDate"
                                            value={moment(this.state.headerStartDate).format(
                                              "MM/DD/YYYY"
                                              )}
                                              placeholder="mm / dd / yyyy"
                                              />

                                        <span className="calendar_img">
                                            <DatePicker
                                                selected={new Date(this.state.headerStartDate)}
                                                onChange={(e) => this.handleChangeDate(e, 'headerStartDate')}
                                                minDate={moment().tz("US/Mountain").toDate()}
                                                placeholder="mm/dd/yyyy"
                                                customInput={
                                                    <span className="calendar">
                                                        <CalendarIcon />
                                                    </span>
                                                }
                                            />
                                        </span>
                                        <Select
                                            options={hours}
                                            value={this.state.headerStart.hours}
                                            name='hours'
                                            placeholder="7"
                                            onChange={(e) => this.handleTimeHours(e, 'headerStartDate')} />
                                        <Select
                                            options={minutes}
                                            value={this.state.headerStart.minutes}
                                            name='minutes'
                                            placeholder="30"
                                            onChange={(e) => this.handleTimeMin(e, 'headerStartDate')} />
                                        <Select
                                            options={state}
                                            value={this.state.headerStart.state}
                                            name='state'
                                            placeholder="AM"
                                            onChange={(e) => this.handleTimeStamps(e, 'headerStartDate')} />
                                    </>
                                </div>
                            </div>
                        </div>
                        {/* endDate */}
                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                <label>End Date & Time (MT)</label>
                                <div className="form_group_countdown">
                                    <>
                                        <TextField type="text" name="countDownDate"
                                            value={moment(this.state.headerEndDate).format(
                                                "MM/DD/YYYY"
                                            )}
                                            placeholder="mm / dd / yyyy"
                                        />

                                        <span className="calendar_img">
                                            <DatePicker
                                                selected={this.state.headerEndDate}
                                                onChange={(e) => this.handleChangeDate(e, 'headerEndDate')}
                                                minDate={moment().tz("US/Mountain").toDate()}
                                                placeholder="mm/dd/yyyy"
                                                customInput={
                                                    <span className="calendar">
                                                        <CalendarIcon />
                                                    </span>
                                                }
                                            />
                                        </span>
                                        <Select
                                            options={hours}
                                            value={this.state.headerEnd.hours}
                                            name='hours'
                                            placeholder="7"
                                            onChange={(e) => this.handleTimeHours(e, 'headerEndDate')} />
                                        <Select
                                            options={minutes}
                                            value={this.state.headerEnd.minutes}
                                            name='minutes'
                                            placeholder="30"
                                            onChange={(e) => this.handleTimeMin(e, 'headerEndDate')} />
                                        <Select
                                            options={state}
                                            value={this.state.headerEnd.state}
                                            name='state'
                                            placeholder="AM"
                                            onChange={(e) => this.handleTimeStamps(e, 'headerEndDate')} />
                                    </>
                                </div>
                            </div>
                        </div>
                      </>}
                      {this.state.isFooter && <>
                        <h3 className="w_100 d_block">Footer</h3>
                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                <label>Start Date & Time (MT)</label>
                                <div className="form_group_countdown">
                                    <>
                                        <TextField type="text" name="countDownDate"
                                            value={moment(this.state.footerStartDate).format(
                                              "MM/DD/YYYY"
                                              )}
                                              placeholder="mm / dd / yyyy"
                                              />

                                        <span className="calendar_img">
                                            <DatePicker
                                                selected={new Date(this.state.footerStartDate)}
                                                onChange={(e) => this.handleChangeDate(e, 'footerStartDate')}
                                                minDate={moment().tz("US/Mountain").toDate()}
                                                placeholder="mm/dd/yyyy"
                                                customInput={
                                                    <span className="calendar">
                                                        <CalendarIcon />
                                                    </span>
                                                }
                                            />
                                        </span>
                                        <Select
                                            options={hours}
                                            value={this.state.footerStart.hours}
                                            name='hours'
                                            placeholder="7"
                                            onChange={(e) => this.handleTimeHours(e, 'footerStartDate')} />
                                        <Select
                                            options={minutes}
                                            value={this.state.footerStart.minutes}
                                            name='minutes'
                                            placeholder="30"
                                            onChange={(e) => this.handleTimeMin(e, 'footerStartDate')} />
                                        <Select
                                            options={state}
                                            value={this.state.footerStart.state}
                                            name='state'
                                            placeholder="AM"
                                            onChange={(e) => this.handleTimeStamps(e, 'footerStartDate')} />
                                    </>
                                </div>
                            </div>
                        </div>

                        {/* endDate */}
                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                <label>End Date & Time (MT)</label>
                                <div className="form_group_countdown">
                                    <>
                                        <TextField type="text" name="countDownDate"
                                            value={moment(this.state.footerEndDate).format(
                                                "MM/DD/YYYY"
                                            )}
                                            placeholder="mm / dd / yyyy"
                                        />

                                        <span className="calendar_img">
                                            <DatePicker
                                                selected={this.state.footerEndDate}
                                                onChange={(e) => this.handleChangeDate(e, 'footerEndDate')}
                                                minDate={moment().tz("US/Mountain").toDate()}
                                                placeholder="mm/dd/yyyy"
                                                customInput={
                                                    <span className="calendar">
                                                        <CalendarIcon />
                                                    </span>
                                                }
                                            />
                                        </span>
                                        <Select
                                            options={hours}
                                            value={this.state.footerEnd.hours}
                                            name='hours'
                                            placeholder="7"
                                            onChange={(e) => this.handleTimeHours(e, 'footerEndDate')} />
                                        <Select
                                            options={minutes}
                                            value={this.state.footerEnd.minutes}
                                            name='minutes'
                                            placeholder="30"
                                            onChange={(e) => this.handleTimeMin(e, 'footerEndDate')} />
                                        <Select
                                            options={state}
                                            value={this.state.footerEnd.state}
                                            name='state'
                                            placeholder="AM"
                                            onChange={(e) => this.handleTimeStamps(e, 'footerEndDate')} />
                                    </>
                                </div>
                            </div>
                        </div>
                      </>}
                      {this.state.isAppVisibility && <>
                        <hr></hr>
                        <div className="form_group form_group_input d_flex d_flex_align_center">
                          <label className="mb_0">App Visibility</label>
                          <input
                            className="ml_25"
                            type="checkbox"
                            checked={this.state.appVisibility}
                            onChange={(e) => this.updateState({ appVisibility: e.target.checked })}
                          />
                        </div>
                      </>}
                  </div>
                    <div className="cat_btns text_center">
                        <button type="button" onClick={this.CloseModal}>
                            CANCEL
                        </button>
                        <button className={`${this.state.isEdited ? "active" : ""}`} disabled={!this.state.isEdited} onClick={(e) => this.submitFn(e)}>
                            {this.state.updateId ? 'UPDATE' : 'SAVE'}
                        </button>
                    </div>
                </form>
            </div>
        </div>}
        {this.state.clonePopup &&
            <div className="delete_popup_wrapper clone_popup_wrapper">
                <span className="popup_overlay" onClick={this.cancelClone}></span>
                <div className="popup_inner">
                    <div className="popup_wrapper">
                      <h2 className="popup_title text_center relative">
                          Clone Configuration
                      </h2>
                      <form>
                        <div className="details">
                            <div className="form_group">
                                <label>From</label>
                                <div className="form_group_control">
                                    <div className="form_group_input form_group_select">
                                        <select
                                          value={this.state.from}
                                          className="custom"
                                          name='from'
                                          id='from'
                                          onChange={this.onInputChangeDropDown}
                                        >
                                          <option value="" selected>Select Environment</option>
                                          {instance.map((e, key) => {
                                              return <option key={key} value={e}>{e}</option>;
                                          })}
                                        </select>
                                    </div>
                                    <span style={{ color: 'red' }}>{this.validator.message('', this.state.from === '' ? '' : this.state.from, 'required')}</span>
                                </div>
                            </div>
                            <div className="form_group">
                                <label>To</label>
                                <div className="form_group_control">
                                    <div className="form_group_input form_group_select">
                                        <select
                                          value={this.state.to}
                                          className="custom"
                                          name='to'
                                          id='to'
                                          onChange={this.onInputChangeDropDown}
                                        >
                                          <option value="" selected>Select Environment</option>
                                          {instance.map((e, key) => {
                                              return <option key={key} value={e}>{e}</option>;
                                          })}
                                        </select>
                                    </div>
                                    <span style={{ color: 'red' }}>{this.validator.message('', this.state.to === '' ? '' : this.state.to, 'required')}</span>
                                </div>
                            </div>
                            <div className="content_management">
                              <div class="btn_wrapper">
                                <button class="orangeBTN" type="button" onClick={this.submitClone}>Submit</button>
                              </div>
                            </div>
                        </div>
                      </form>
                    </div>
                </div>
            </div>
        }
        <div className={`user_popup ${this.state.isClone ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>You are about to copy ALL festival date configurations from the selected environement, to the current environement. Are you sure you want to continue?</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn" onClick={this.cancelClone}> NO </button>
                <button className="small_btn active" onClick={this.yesCloneData}> YES </button>
              </div>
            </div>
          </div>
        </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}
